import {
  ApplicationRef,
  ComponentFactoryResolver,
  ComponentRef,
  EmbeddedViewRef,
  Injectable,
  Injector,
  Type,
} from '@angular/core';
import { fromEvent, Observable } from 'rxjs';
import { map, shareReplay, startWith } from 'rxjs/operators';

export const MOBILE_WIDTH_SIZE = 768;

@Injectable()
export class ModalService {
  public mobile$: Observable<boolean>;
  private isOpen: boolean = false;
  private dialog: ComponentRef<any>;

  constructor(private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector,
  ) {
    this.mobile$ = fromEvent(window, 'resize').pipe(
      map((event: any) => event.srcElement.innerWidth),
      startWith(window.innerWidth),
      map((width: number) => width < MOBILE_WIDTH_SIZE),
      shareReplay(1)
    );
  }

  public isModalOpen(): boolean {
    return this.isOpen;
  }

  open<T>(typeRef: Type<T>): ComponentRef<T> {
    if (this.isOpen) {
      return;
    }
    this.isOpen = true;
    // Create the Sidebar component
    this.dialog = this.componentFactoryResolver
      .resolveComponentFactory(typeRef)
      .create(this.injector);

    // Attach it to the running angular instance
    this.appRef.attachView(this.dialog.hostView);

    // Place it on the body
    const sidebarDom = (this.dialog.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
    document.body.appendChild(sidebarDom);
    return this.dialog;
  }

  close(): void {
    this.isOpen = false;
    if (!!this.dialog) {
      this.dialog.destroy();
    }
  }
}
